<!-- eslint-disable -->
<template>
    <div class="page-content">
      <section class="row">
        <div class="col-12 col-lg-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <h3 class="card-title text-dark text-left">A. MOBILE BANKING – BANK SYARIAH INDONESIA (BSI) ex. BRIS</h3>
                <ol class="card-text text-dark">
                  <li>Login</li>
                  <li>Pilih menu <strong>Bayar</strong></li>
                  <li>Pilih Pembayaran <strong>Akademik</strong></li>
                  <li>Isi Nama Akademik dengan Kode : <strong>9457 - YAYASAN AL KAUTSAR</strong></li>
                  <li>Isi ID Pelanggan/Kode Bayar dengan 6 digit terakhir virtual account  : <strong> {{ this.dataSiswa.nis }} </strong></li>
                  <li>Total tagihan yang muncul sudah otomatis di tambahkan biaya admin bank sebesar Rp. 2.000 </li>
                  <li>Lanjutkan ke proses Pembayaran </li>
                </ol>

              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="row">
        <div class="col-12 col-lg-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <h3 class="card-title text-dark text-left">B.	ATM – BANK SYARIAH INDONESIA (BSI) ex. BRIS</h3>
                <ol class="card-text text-dark">
                  <li>Login</li>
                  <li>Pilih menu <strong>Pembayaran</strong></li>
                  <li>Pilih Pembayaran <strong>Akademik</strong></li>
                  <li>Isi Nama Akademik dengan Kode : <strong>9457 - YAYASAN AL KAUTSAR</strong></li>
                  <li>Isi ID Pelanggan/Kode Bayar dengan 6 digit terakhir virtual account  : <strong> {{ this.dataSiswa.nis }} </strong></li>
                  <li>Total tagihan yang muncul sudah otomatis di tambahkan biaya admin bank sebesar Rp. 2.000 </li>
                  <li>Lanjutkan ke proses Pembayaran </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
</template>
<!-- eslint-disable -->
<script>
export default {
  name: "PetunjukBRIS",
  props: {
    dataSiswa: {},
  }
};
</script>